import React from "react";
import { Modal } from "../shared";
import { useNestedOverlay } from "./nestedOverlay";

// Çekmece z 9999'da; onay modal'ı onun üstünde açılır.
export const OVER_DRAWER_Z = 10050;

function TaskConfirmModal({
  open,
  title,
  message,
  confirmLabel = "Sil",
  busy = false,
  busyLabel = "Siliniyor...",
  onConfirm,
  onClose,
}) {
  useNestedOverlay(open);
  return (
    <Modal open={open} onClose={busy ? undefined : onClose} maxWidth="sm" zIndex={OVER_DRAWER_Z}>
      <Modal.Header title={title} onClose={busy ? undefined : onClose} />
      <Modal.Body>
        <p className="text-sm text-gray-600">{message}</p>
      </Modal.Body>
      <Modal.Footer className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onClose}
          disabled={busy}
          className="px-3 py-1.5 rounded-lg text-sm font-Medium text-gray-600 hover:bg-gray-100 disabled:opacity-50"
        >
          Vazgeç
        </button>
        <button
          type="button"
          onClick={onConfirm}
          disabled={busy}
          className="px-3 py-1.5 rounded-lg text-sm font-Medium bg-fifth text-white hover:opacity-90 disabled:opacity-50"
        >
          {busy ? busyLabel : confirmLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default TaskConfirmModal;
